import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {
  DiccionarioControllerService,
  DiccionarioElementoDTO,
  SolicitudRetiradaControllerService,
  SolicitudRetiradaEstadoControllerService,
  SolicitudRetiradaFilterDTO,
  SolicitudReutilizacionControllerService,
  SolicitudReutilizacionEstadoDTO,
  SubTipoEnvaseControllerService,
  SubTipoEnvaseDTO,
  SubTipoEnvaseFilterDTO,
  TipoEnvasesControllerService,
  TipoEnvasesDTO,
  UsuarioSDDRCaDTO
} from "api-rest";
import {EmpusaAuthenticationService} from "@empusa/empusa-core";
import {DatePipe} from "@angular/common";
import {SpinnerService} from "../../../services/spinner.service";
import {DownloadService} from "../../../services/download.service";
import {SnackbarService} from "../../../services/snackbar.service";
import {FormatCurrencyPipe} from "../../../share/pipe/FormatCurrency.pipe";
import {Combo, ComboService} from "../../../services/combo.service";
import {zip, of} from "rxjs";
import {OpenSddrService} from "../../../services/open-sddr.service";
import Swal from "sweetalert2";
import moment from "moment/moment";
import {
  OpenSddrRequestsWithdrawnDetailComponent
} from '../open-sddr-requests-withdrawn-detail/open-sddr-requests-withdrawn-detail.component';
import { OpenSddrRequestsWithdrawnRejectDialogComponent } from '../open-sddr-requests-withdrawn-reject-dialog/open-sddr-requests-withdrawn-reject-dialog.component';

@Component({
  selector: 'app-components-open-sddr-requests-withdrawn-search',
  templateUrl: './open-sddr-requests-withdrawn-search.component.html',
  styleUrls: ['./open-sddr-requests-withdrawn-search.component.scss']
})
export class OpenSddrRequestsWithdrawnSearchComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  totalElements: number = 0;
  totalSearch: number = 0;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  defaultFilter: boolean = true;
  ocultarBuscador: boolean = true;

  headArray: any = [
    {
      Head: 'ID',
      FieldName: 'id'
    },
    {
      Head: 'Fecha solicitud',
      FieldName: 'fechaSolicitud',
      renderValue: (item: any) => this.datePipe.transform(item.fechaSolicitud, 'dd/MM/yyyy'),
    },
    {
      Head: 'Razón social usuario',
      renderValue: (item: any) => item.adherido?.razonSocial ?? item.poseedor?.razonSocial,
    },
    {
      Head: 'Provincia usuario',
      FieldName: 'provincia',
      renderValue: (item: any) => {
        let user = item.adherido ?? item.poseedor;
        // Primero "Física"
        let domicilio = user?.domicilios?.find((dom: any) => dom.tipoDireccion.descripcion === "Física");
        // Si no existe,"Social"
        if (!domicilio) {
          domicilio = user?.domicilios?.find((dom: any) => dom.tipoDireccion.descripcion === "Social");
        }
        // else null
        return domicilio?.provincia?.nombre || '';
      }
    },
    {
      Head: 'Acondicionador',
      FieldName: 'gestorAcondicionador',
      Attribute: 'razonSocial'
    },
    {
      Head: 'NIMA Acondic.',
      FieldName: 'gestorAcondicionador',
      Attribute: 'nima'
    },
    {
      Head: 'Provincia Acondic.',
      FieldName: 'provincia',
      renderValue: (item: any) => {
        const domicilio = item?.gestorAcondicionador?.domicilios?.find((dom: any) => dom.tipoDireccion.descripcion === "Física");
        return domicilio?.provincia?.nombre || '';
      }
    },
    {
      Head: 'Tipo envase',
      FieldName: 'tipoEnvase',
      Attribute: 'descripcion'
    },
    // {
    //   Head: 'Subtipo envase',
    //   FieldName: 'subTipoEnvase',
    //   Attribute: 'descripcion'
    // },
    //{
    //  Head: 'Lote envase',
    //  FieldName: 'loteEnvase',
    //},
    {
      Head: 'Cantidad a retirar (Ud)',
      FieldName: 'cantidadRetirarUd',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.cantidadRetirarUd),
       },
       {
      Head: 'Cantidad retirada (Ud)',
      FieldName: 'solicitudInformeRetirada',
       renderValue: (item: any) => { 
        let sumaTotal : number = 0;
        let arrayEnvasesRetirados : any = item?.solicitudInformeRetirada;
        arrayEnvasesRetirados.forEach((el : any) =>{
          sumaTotal += Number(el?.envasesRetiradosUd) || 0
          
        })
      return sumaTotal}

    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      Attribute: 'descripcion',
       tooltipHeader: this.canViewResource('PO-GESTOR')
         ? "Resumen de estados:\n ·Pendiente de Retirada: solicitud de retirada emitida. Pendiente de retirada por parte del acondicionador.\n ·Completada: el acondicionador ha realizado la retirada y ha cumplimentado el informe de retirada.\n ·Aceptada: solicitud de retirada aceptada por ENVALORA.\n ·Rechazada: solicitud de retirada rechazada por ENVALORA.\n ·Prefacturada: prefactura por retorno de depósitos de envases aptos al usuario del SDDR Abierto, emitida por ENVALORA."
         : this.canViewResource('PO-POSEEDOR')
          ? "Resumen de estados:\n·Borrador: solicitud en proceso de cumplimentación. Pendiente de envío al acondicionador.\n ·Pendiente de Retirada: solicitud de retirada emitida. Pendiente de retirada por parte del acondicionador.\n ·Completada: el acondicionador ha realizado la retirada y ha cumplimentado el informe de retirada.\n ·Aceptada: solicitud de retirada aceptada por ENVALORA. Los depósitos de los envases aptos retirados se contabilizan para la emisión de la prefactura.\n ·Rechazada: solicitud de retirada rechazada por ENVALORA.\n ·Prefacturada: prefactura por retorno de depósitos de envases aptos emitida por ENVALORA."
          : ""

    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      check: this.canViewResource('SDDR-CA-ENV-GEST'),
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Editar',
          show: {params: 'canAccessView', accion: 'view'},
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: {
            params: 'canAccessDelete',
            accion: 'delete',
          },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'send_request',
              name: 'Enviar solicitud',
              show: {
                params: 'canAccessSendRequest',
                accion: 'send_request',
              },
            },
            {
              nameButton: 'complete_request',
              name: 'Completar solicitud',
              show: {
                params: 'canAccessCompleteRequest',
                accion: 'complete_request',
              },
            },
            {
              nameButton: 'accept_request',
              name: 'Aceptar solicitud',
              show: {
                params: 'canAccessAcceptRequest',
                accion: 'accept_request',
              },
            },
            {
              nameButton: 'reject_request',
              name: 'Rechazar solicitud',
              show: {
                params: 'canAccessRejectRequest',
                accion: 'reject_request',
              },
            },
            {
              nameButton: 'generate_delivery_note',
              name: 'Generar Albarán de retirada',
              show: {
                params: 'canAccessDeliveryNote',
                accion: 'generate_delivery_note',
              },
            },
          ],
        },
      ],
      width: '12',
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  searchForm: FormGroup;
  tiposUsuariosSddr!: UsuarioSDDRCaDTO[];
  tiposUsuarios!: Combo[];
  tiposEnvases!: TipoEnvasesDTO[];
  subtiposEnvases!: SubTipoEnvaseDTO[];
  estados!: SolicitudReutilizacionEstadoDTO[];
  gestores!: any;
  gestoresEndpoint = this.environment.urlBackCore + 'api/v1/poseedores/gestores-residuos?acondicionadorEnvase=true';
  listaPoseedores = this.environment.urlBackCore + 'api/v1/poseedores/poseedor';

  // Poseedores completados
  defaultUsuariossddrParameters = { 'estado.id': 4 };

  updateList: boolean = false;
  orden: DiccionarioElementoDTO[] = [];
  mostrarFiltros: boolean = true;
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private downloadService: DownloadService,
    private snackBarSrv: SnackbarService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private comboService: ComboService,
    private tipoEnvasesCtrSrv: TipoEnvasesControllerService,
    private solicitudReutilizacionCtrSrv: SolicitudReutilizacionControllerService,
    private solicitudRetiradaCtrSrv: SolicitudRetiradaControllerService,
    private solicitudRetiradaEstadoCtrSrv: SolicitudRetiradaEstadoControllerService,
    private subtipoEnvaseCtrSrv: SubTipoEnvaseControllerService,
    private datePipe: DatePipe,
    private openSddrSrv: OpenSddrService,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    this.searchForm = this.formBuilder.group({
      tipoUsuario: [{value: null, disabled: false}],
      idUsuario: [{value: null, disabled: false}, [Validators.pattern('^[0-9;]+$')]],
      usuarioSDDRCA: [{value: null, disabled: false}],
      tipoEnvase: [{value: null, disabled: false}],
      //subtipoEnvase: [{value: null, disabled: false}],
      loteEnvase: [{value: null, disabled: false}],
      gestorAcondicionador: [{value: null, disabled: false}],
      fechaDesde: [{value: null, disabled: false}],
      fechaHasta: [{value: null, disabled: false}],
      estado: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }

  ngOnInit() {
    this.cargarCombos();
    this.headArray = !this.canViewResource('SDDR-CA-ENV-GEST') || !this.canViewResource('SDDR-CA-ENV-CONS')
      ? this.headArray
      : this.headArray.filter(
        (head: any) =>
          head.FieldName !== 'provincia'
      );
    this.search(true, true);
  }

  cargarCombos(): void {
    this.tiposUsuarios = this.comboService.getTiposUsuarioSolicitud();

    const tipoEnvaseFilter = {sddrca: true};
    const subtipoEnvaseFilter: SubTipoEnvaseFilterDTO = {tipoEnvase: {sddrca: true}};
    this.spinnerSrv.loadingShow();

    const usuariosSddrObservable = (this.canAccessSDDRCAUser())
          ? this.solicitudReutilizacionCtrSrv.findAllUsuariosAsociados()
          : of([]);

    zip(
      this.tipoEnvasesCtrSrv.findAll(tipoEnvaseFilter, {page: 0, size: 100}),
      usuariosSddrObservable,
      this.subtipoEnvaseCtrSrv.listarSubTipoEnvases(subtipoEnvaseFilter, {page: 0, size: 100}),
      this.solicitudRetiradaEstadoCtrSrv.listarComunidades({}, { page: 0, size: 500 }),
      this.diccionarioControllerService.listarElementos(['ORDEN_SDDR_ABIERTO_SOLICITUDES_RETIRADA_BUSQUEDA'])
    ).subscribe({
      next: (responses: any[]) => {
        this.spinnerSrv.loadingHide();
        this.tiposEnvases = responses[0].datos;
        this.tiposUsuariosSddr = responses[1].filter((item:any) => item.tipoUsuario !== 'ADHERIDO');
        this.subtiposEnvases = responses[2].datos;
        this.estados = responses[3].datos;
        this.orden = responses[4]['ORDEN_SDDR_ABIERTO_SOLICITUDES_RETIRADA_BUSQUEDA'];
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  getGestorDescription(gestor: any) {
    const parts = [
      gestor?.razonSocial,
      gestor?.nima,
      gestor?.centro
    ].filter(Boolean);
    return parts.join(' - ');

  }

  getUsuariossddrDescription(obj: any) {
      const parts = [
      obj?.razonSocial,
      obj?.nima,
      obj?.denominacionCentro
    ].filter(Boolean);
    return parts.join(' - ');
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'gestorAcondicionador': {
        return this.searchForm.get('gestorAcondicionador') as FormControl;
      }
      case 'usuarioSDDRCA': {
        return this.searchForm.get('usuarioSDDRCA') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  getUsuariosddrObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: `${searchterm}`,
      'estado.id': 4,
    };
  }

  getObjectQuery(searchterm: string) {
    return {
      descripcion: searchterm
    };
  }
  getGestorQuery(searchterm: string) {
    return {
      razonSocial: `${searchterm}`,
    };
  }
  public rightHolder(controlName: string) {
    let cl2 = '';
    if ((this.searchForm.controls[controlName]?.touched || this.searchForm.controls[controlName]?.dirty)
      && this.searchForm.controls[controlName]?.errors) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.search();
    }
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.search();
  }

  limpiar(): void {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  canAccessSDDRCAUser(): boolean {
    return this.canViewResource('PO-POSEEDOR') || this.canViewResource('AD-ADHERIDO');
  }

  canAccessGestor(): boolean {
    return this.canViewResource('PO-GESTOR');
  }

  canAccessEnvalora(): boolean {
    return this.canViewResource('SDDR-CA-ENV-GEST') || this.canViewResource('SDDR-CA-ENV-CONS');
  }

  canAccessCrearSolicitud(): boolean {
    return this.authService.can('sddr-ca-solicitudes-retirada', 'create');
  }

  canAccessExportar(): boolean {
    return this.authService.can('sddr-ca-solicitudes-retirada', 'update-exportar');
  }

  canAccessCrearAutofactura(): boolean {
    return this.authService.can('sddr-ca-solicitudes-retirada', 'create-autofactura');
  }

  canAccessAll(list: any) {
    const permissions = {
      view: this.authService.can('sddr-ca-solicitudes-retirada', 'view'),
      delete: this.authService.can('sddr-ca-solicitudes-retirada', 'update-delete'),
      send: this.authService.can('sddr-ca-solicitudes-retirada', 'update-send'),
      complete: this.authService.can('sddr-ca-solicitudes-retirada', 'update-complete'),
      accept: this.authService.can('sddr-ca-solicitudes-retirada', 'update-accept'),
      reject: this.authService.can('sddr-ca-solicitudes-retirada', 'update-reject'),
      albaran: this.authService.can('sddr-ca-solicitudes-retirada', 'albaran'),
    };

    return list.map((objeto: any) => {
      const user =  objeto.creadoPor == this.authService.getCurrentUserMail();
      const gestorEnvalora = this.canViewResource('SDDR-CA-ENV-GEST');
      const gestorPoseedor = this.canViewResource('PO-GESTOR');
      const deleteCondition = user || gestorEnvalora;

      return {
        ...objeto,
        canAccessView: permissions.view,
        canAccessDelete: permissions.delete && objeto?.estado?.id === 1 && deleteCondition,
        canAccessSendRequest: permissions.send && objeto?.estado?.id === 1,
        canAccessCompleteRequest: permissions.complete && objeto?.estado?.id === 2 && gestorPoseedor,
        canAccessAcceptRequest: permissions.accept && objeto?.estado?.id === 3,
        canAccessRejectRequest: permissions.reject && objeto?.estado?.id === 3,
        canAccessDeliveryNote: permissions.albaran && objeto?.estado?.id >= 2
      };
    });
  }

  private getBackendFilter() {
    let fechaBusqueda: Array<string> = [];
    let fechaDesde = this.searchForm.get('fechaDesde')?.value;
    let fechaHasta = this.searchForm.get('fechaHasta')?.value;

    if (fechaDesde) {
      let formatDateDesde = moment(new Date(fechaDesde)).format('YYYY-MM-DD');
      formatDateDesde = `gte(${formatDateDesde})`;
      fechaBusqueda.push(formatDateDesde);
    }
    if (fechaHasta) {
      let formatDateHasta = moment(
        new Date(this.searchForm.get('fechaHasta')?.value)
      ).format('YYYY-MM-DD');
      if (fechaDesde) {
        formatDateHasta = `and(lte(${formatDateHasta}))`;
      } else {
        formatDateHasta = `lte(${formatDateHasta})`;
      }
      fechaBusqueda.push(formatDateHasta);
    }

    const selectUsuarioSddr = this.searchForm.get('usuarioSDDRCA')?.value;
    let usuarioSddrFilter: any;
    if(selectUsuarioSddr && selectUsuarioSddr.length > 0){
      usuarioSddrFilter = {
        id: selectUsuarioSddr?.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        ),
      }
    }else{
      usuarioSddrFilter = {
        id: [this.searchForm.get('idUsuario')?.value]
      }
    }
    const selectEstado = this.searchForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    const backendFilter: SolicitudRetiradaFilterDTO = {
      tipoUsuario: this.searchForm.get('tipoUsuario')?.value,
      idUsuario: this.searchForm.get('idUsuario')?.value ? this.searchForm.get('idUsuario')?.value : undefined,
      usuarioSDDRCA: usuarioSddrFilter,
      tipoEnvase: {id: this.searchForm.get('tipoEnvase')?.value},
      //subTipoEnvase: {id: this.searchForm.get('subtipoEnvase')?.value},
      loteEnvase: this.searchForm.get('loteEnvase')?.value ? this.searchForm.get('loteEnvase')?.value : undefined,
      gestorAcondicionador: this.searchForm.get('gestorAcondicionador')?.value ? {id: this.searchForm.get('gestorAcondicionador')?.value?.id} : undefined,
      estado: {id: selectEstadosId},
      fechaSolicitud: fechaBusqueda
    };

    return backendFilter;
  }

  search(initPage:boolean = false, init?: boolean) {
    if(initPage){
      this.pageNumber = 0;
    }
    let filtro: SolicitudRetiradaFilterDTO = this.getBackendFilter();
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    this.spinnerSrv.loadingShow();
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    this.openSddrSrv.buscarSolicitudesRetirada(filtro, {
      page: page,
      size: this.pageSize,
      sort: ['id,desc']
    },
        orden,
        tipoOrden).subscribe({
      next: (data: any) => {
        this.spinnerSrv.loadingHide();
        if (data) {
          this.flagSearch = data.datos?.length != 0;
          this.ocultarBuscador = ((this.canViewResource('AD-ADHERIDO') || this.canViewResource('PO-POSEEDOR')) && (!this.flagSearch && init == true));
          this.gridArray = this.canAccessAll(data.datos);
          this.totalElements = data.paginacion?.totalElements ?? 0;
          this.totalSearch = this.gridArray.length;
        }
      },
      error: (error: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al buscar las solicitudes de retirada',
          'error'
        );
      },
    });
  }

  exportarExcel() {
    let filter = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.solicitudRetiradaCtrSrv.exportCSV2(filter)
      .subscribe({
        next: (response) => {
          this.downloadService.exportModal();
          this.spinnerSrv.loadingHide();
          // this.downloadService.downloadBlob(response, 'solicitudesRetirada_SDDR_CA.csv');
        },
        error: (err: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al exportar las solicitudes de retirada',
            'error'
          );
        },
      });
  }

  confirmacionAutofactura(): void {
    Swal
      .fire({
        text: '¿Desea crear prefactura de las solicitudes seleccionadas en la tabla?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.crearAutofactura();
        }
      });
  }
  crearAutofactura() {
    const list = this.gridArray.filter((x) => x.checked === true);

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        `Debe seleccionar al menos una solicitud para generar una prefactura`,
        'error'
      );
      return;
    }
    this.spinnerSrv.loadingShow();
    this.solicitudRetiradaCtrSrv.crearAutofactura1(list)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha generado la prefactura correctamente.',
            'success'
          );
          this.search();
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          let message = err.error?.arguments[0] ?? 'Ha ocurrido un error al generar la prefactura';
          this.snackBarSrv.showSnackBar(message, 'error');
        },
      });
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalDetailRequest(element);
    } else if (element.nameButton == 'delete') {
      this.confirmDelete(element);
    } else if (element.nameButton == 'send_request') {
      this.confirmSend(element);
    } else if (element.nameButton == 'complete_request') {
      this.confirmComplete(element);
    } else if (element.nameButton == 'accept_request') {
      this.confirmAccept(element);
    } else if (element.nameButton == 'reject_request') {
      this.openModalMotivoRechazo(element);
    } else if (element.nameButton == 'generate_delivery_note') {
      this.confirmGenerateDeliveryNote(element);
    }
  }

  checked(event: any) {
    if (event.estado.id != 4) {
      this.snackBarSrv.showSnackBar(
        'Solo se permitirá prefacturar solicitudes en estado Aceptada',
        'error'
      );
      event.checked = null;
    }
  }

  openModalDetailRequest(solicitud?: any): void {
    const dialogRef = this.dialog.open(
      OpenSddrRequestsWithdrawnDetailComponent,
      {
        width: '1460px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          solicitudId: solicitud?.id,
          soloLecturaInforme: !(this.authService.can('sddr-ca-solicitudes-retirada-detalle', 'edit-informe') && solicitud?.estado?.id === 2),
          soloLecturaDatos: !(this.authService.can('sddr-ca-solicitudes-retirada-detalle', 'edit-datos') && (solicitud?.estado?.id === 1 || !solicitud?.id))
        },
        disableClose: true,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.search();
      }
    });
  }

  confirmDelete(element?: any): void {
    Swal.fire({
      text: '¿Desea eliminar la solicitud de Retirada de envases?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.deleteRequest(element?.id!);
        }
      });
  }

  confirmSend(element?: any): void {
    Swal.fire({
      text: '¿Desea enviar la solicitud de Retirada de envases?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.sendRequest(element?.id!);
        }
      });
  }

  confirmComplete(element?: any): void {
    Swal.fire({
      text: '¿Desea completar la solicitud de Retirada de envases?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.completeRequest(element?.id!);
        }
      });
  }

  confirmAccept(element?: any): void {
    Swal.fire({
      text: '¿Desea aceptar la solicitud de Retirada de envases?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.acceptRequest(element?.id!);
        }
      });
  }

  confirmGenerateDeliveryNote(element?: any): void {
    Swal.fire({
      text: '¿Desea generar el albarán de retirada?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.generateDeliveryRequest(element?.id!);
        }
      });
  }

  deleteRequest(id: number): void {
    this.spinnerSrv.loadingShow();
    this.solicitudRetiradaCtrSrv.deleteByIdSolicitudRetirada(id)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha eliminado la solicitud de retirada correctamente',
            'success'
          );
          this.search();
        },
        error: (err) => {
          console.log(err);
          this.spinnerSrv.loadingHide();
        },
      });
  }

  openModalMotivoRechazo(item:any){
    const dialogRef = this.dialog.open(
      OpenSddrRequestsWithdrawnRejectDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: item,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.search();
      }
    });
  }

  sendRequest(id: number): void {
    this.spinnerSrv.loadingShow();
    this.solicitudRetiradaCtrSrv.enviarSolicitud1(id)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha enviado la solicitud de retirada de envases correctamente',
            'success'
          );
          this.search();
        },
        error: (err) => {
          console.log(err);
          this.spinnerSrv.loadingHide();
        },
      });
  }

  completeRequest(id: number): void {
    this.spinnerSrv.loadingShow();
    this.solicitudRetiradaCtrSrv.completarSolicitud(id)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha completado la solicitud de retirada de envases correctamente',
            'success'
          );
          this.search();
        },
        error: (err) => {
          console.log(err);
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'No se puede completar la solicitud porque no tiene ningún informe de retirada asociado',
            'error'
          );
        },
      });
  }

  acceptRequest(id: number): void {
    this.spinnerSrv.loadingShow();
    this.solicitudRetiradaCtrSrv.aceptarSolicitud1(id)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha aceptado la solicitud de retirada de envases correctamente',
            'success'
          );
          this.search();
        },
        error: (err) => {
          console.log(err);
          this.spinnerSrv.loadingHide();
        },
      });
  }

  generateDeliveryRequest(id: number): void {
    this.spinnerSrv.loadingShow();
    this.solicitudRetiradaCtrSrv.generarAlbaran(id)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();

          const today = new Date();
          const yyyy = today.getFullYear();
          const mm = String(today.getMonth() + 1).padStart(2, '0');
          const dd = String(today.getDate()).padStart(2, '0');
          const formattedDate = `${yyyy}${mm}${dd}`;
          const filename =  `${formattedDate}_${id}_Albaran.pdf`;

          this.downloadService.downloadBlob(response, filename); //Fecha + Id solicitud + Albaran // 20250521_81_Albaran.pdf
          this.snackBarSrv.showSnackBar(
            'Se ha generado el albarán de retirada de envases correctamente.',
            'success'
          );
          this.search();
        },
        error: (err) => {
          console.log(err);
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al generar el albarán.',
            'error'
          );
          this.spinnerSrv.loadingHide();
        },
      });
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  
  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => {
          if (v?.id !== undefined && filtro.value?.id !== undefined) return v.id !== filtro.value.id;
          if (v?.clase !== undefined && filtro.value?.clase !== undefined) return v.clase !== filtro.value.clase;
          return v !== filtro.value;
        });
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }
    //this.search(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const idUsuario = this.searchForm.get('idUsuario')?.value;
    if (idUsuario) filtros.push({ label: ` ${idUsuario}`, campo: 'idUsuario' });

    const usuarios = this.searchForm.get('usuarioSDDRCA')?.value as any[];
    if (usuarios?.length) {
      usuarios.forEach((u: any) => {
        const label = [u?.razonSocial, u?.nima, u?.denominacion].filter(Boolean).join(' - ') || String(u);
        filtros.push({ label, campo: 'usuarioSDDRCA', value: u });
      });
    }

    const acondicionador = this.searchForm.get('gestorAcondicionador')?.value;
    if (acondicionador) {
      const label = [acondicionador?.razonSocial, acondicionador?.nima, acondicionador?.centro].filter(Boolean).join(' - ') || String(acondicionador);
      filtros.push({ label, campo: 'gestorAcondicionador' });
    }

    const tipoEnvaseId = this.searchForm.get('tipoEnvase')?.value;
    if (tipoEnvaseId !== null && tipoEnvaseId !== undefined && tipoEnvaseId !== '') {
      const found = this.tiposEnvases?.find((t: any) => t.id === tipoEnvaseId);
      filtros.push({ label: found?.descripcion ?? String(tipoEnvaseId), campo: 'tipoEnvase' });
    }

    const loteEnvase = this.searchForm.get('loteEnvase')?.value;
    if (loteEnvase?.trim()) filtros.push({ label: loteEnvase.trim(), campo: 'loteEnvase' });

    const fechaDesde = this.searchForm.get('fechaDesde')?.value;
    if (fechaDesde) filtros.push({ label: ` ${moment(fechaDesde).format('DD/MM/YYYY')}`, campo: 'fechaDesde' });

    const fechaHasta = this.searchForm.get('fechaHasta')?.value;
    if (fechaHasta) filtros.push({ label: ` ${moment(fechaHasta).format('DD/MM/YYYY')}`, campo: 'fechaHasta' });

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((estadoId: any) => {
        const found = this.estados?.find((e: any) => e.id === estadoId);
        filtros.push({ label: found?.descripcion ?? String(estadoId), campo: 'estado', value: estadoId });
      });
    }

const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }
}
